const TestIDs = {
  ACCESSIBILITY: {
    BUTTON: 'accessibility-link',
  },
  ADDRESS_EDIT: {
    ADDRESS_LINE_1: 'address_edit_address_line_1',
    ADDRESS_LINE_2: 'address_edit_address_line_2',
    CITY: 'address_edit_city',
    STATE: 'address_edit_state',
    ZIP_CODE: 'address_edit_zipcode',
    PHONE_NUMBER: 'address_edit_phone_number',
    HERO_HEADER: 'address_edit_hero_header',
    HERO_TEXT: 'address_edit_hero_text',
    SAVE_BUTTON: 'address_edit_save_button',
  },
  ADDRESS_INVALID: {
    EDIT_ADDRESS_BUTTON: 'address_error_edit_address_button',
    HERO_HEADER: 'address_error_hero_header',
    INPUT_ADDRESS_CARD: 'address_error_input_address_card',
  },
  ADDRESS_PREVIEW: {
    PREVIEW_HERO_HEADER: 'address_preview_hero_header',
    BODY_HERO: 'address_preview_hero_body',
    PREVIEW_NEXT_BUTTON: 'address_preview_next_button',
    RESIDENTIAL_ADDRESS_CARD: 'address_preview_residential_address_card',
    SHIPPING_ADDRESS_CARD: 'address_preview_shipping_address_card',
    SHIPPING_ADDRESS_CARD_EDIT_BUTTON: 'address_preview_shipping_address_card_edit_button',
  },
  ADDRESS_SUGGESTION: {
    EDIT_ADDRESS_BUTTON: 'address_suggestion_edit_address_button',
    HERO_HEADER: 'address_suggestion_hero_header',
    INPUT_ADDRESS_CARD: 'address_suggestion_input_address_card',
    SUGGESTED_ADDRESS_CARD: 'address_suggestion_suggested_address_card',
    SUGGESTED_ADDRESS_BUTTON: 'address_suggestion_address_button',
  },
  ACTION_STRIP: {
    CONTAINER: 'action_strip',
  },
  AGREEMENT_MODAL: {
    CONTAINER: 'agreement_modal_container',
    OVERLAY: 'agreement_modal_overlay',
    CLOSE_BUTTON: 'agreement_modal_close_btn',
  },
  ANALYZING: {
    LATER_ANIMATION: 'analyzing_later_animation',
  },
  AUTOCOMPLETE_ADDRESS: {
    LIST: 'autocomplete_address_list',
    LIST_ITEM: 'autocomplete_address_list_item',
  },
  AUTO_SCROLLER: {
    CONTAINER: 'autoscroller_container',
    CTA: 'autoscroller_cta',
  },
  CARD_ORDER_REVIEW: {
    HARD_FAIL_CTA: 'card_order_review_hard_fail_button',
    CTA: 'card_order_review_button',
  },
  CONTACT_INFO: {
    ADDRESS_LINE_1: 'contact_info_address_line_1',
    ADDRESS_LINE_2: 'contact_info_address_line_2',
    CITY: 'contact_info_city',
    STATE: 'contact_info_state',
    ZIP_CODE: 'contact_info_zipcode',
    PHONE_NUMBER: 'contact_info_phone_number',
    SUBMIT_CTA: 'contact_info_submit_cta',
    SUGGESTION_CONTAINER: 'contact_info_suggestion_container',
    SUGGESTION_HEADER: 'contact_info_suggestion_header',
    SUGGESTION_BODY: 'contact_info_suggestion_body',
    SUGGESTION_SEPARATOR: 'contact_info_suggestion_separator',
  },
  ESG_EDUCATION: {
    LEFT_ARROW: 'esg_education_left_arrow',
    RIGHT_ARROW: 'esg_education_right_arrow',
    LETS_GO_BUTTON: 'esg_education_lets_go_button',
    DONE_BUTTON: 'esg_education_done_button',
  },
  INSTITUTIONS: {
    NO_MATCHES_LINK: 'institutions_no_matches_link',
    RESULTS_LIST: 'institutions_results_list',
  },
  INVEST_INTERSTITIAL: {
    NEXT_BUTTON: 'invest_interstitial_next_cta',
    IMAGE: 'invest_interstitial_image',
    TITLE: 'invest_interstitial_title',
    BODY: 'invest_interstitial_body',
    FOOTER: 'invest_interstitial_footer',
  },
  INVESTOR_QUESTIONS: {
    SUBMIT_CTA: 'investor_questions_submit_cta',
  },
  LATER_IRA_RECOMMENDATION: {
    TITLE: 'later_ira_recommendation_title',
    TEXT: 'later_ira_recommendation_text',
    SUBTEXT: 'later_ira_recommendation_subtext',
    SUBMIT_CTA: 'later_ira_recommendation_submit_cta',
  },
  LATER_SUITABILITY_QUESTIONS: {
    NEXT_CTA: 'later_suitability_questions_next_cta',
  },
  MANUAL_FUNDING_SOURCE: {
    ROUTING_NUMBER: 'manual_funding_source_routing_number',
    ACCOUNT_NUMBER: 'manual_funding_source_account_number',
    CONFIRM_ACCOUNT_NUMBER: 'manual_funding_source_confirm_account_number',
    SKIP_CTA: 'manual_funding_sournce_skip_cta',
    SUBMIT_BUTTON: 'manual_funding_source_submit_button',
    ROUNDUP_INTERESTITIAL: 'manual_funding_source_roundup_interestitial',
    ROUNDUP_REDIRECT: 'manual_funding_source_roundup_redirect',
    ROUNDUPS_INFO_NOTE_CLOSE: 'manual_funding_source_roundups_info_note_close',
  },
  FUNDING_PAGE: {
    CORE_IMAGE: 'funding_image_core',
  },
  FUNDING_CHECKING: {
    DIRECT_DEPOSIT_FOOTNOTE: 'funding_checking_direct_deposit_footnote',
    FOOTNOTE: 'funding_checking_footnote',
    TITLE: 'funding_checking_title',
    TEXT: 'funding_checking_text',
    DESCRIPTION: 'funding_checking_description',
    DIRECT_DEPOSIT_BUTTON: 'funding_checking_direct_deposit_button',
    BANK_LINKING_BUTTON: 'funding_checking_bank_linking_button',
    MANUAL_BANK_LINKING_BUTTON: 'funding_checking_manual_bank_linking_button',
  },
  BANK_LINK_SUCCESS: {
    CORE_IMAGE: 'bank_link_success_image_core',
    LATER_IMAGE: 'bank_link_success_image_later',
    SUBMIT_BUTTON: 'bank_link_success_submit_button',
    SURVEY_SELECTOR: 'bank_link_success_survey_selector',
  },
  NAVIGATION_BAR: {
    CONTAINER: 'navigation_bar_container',
    BACK_BUTTON: 'navigation_bar_back_button',
    SKIP_BUTTON: 'navigation_bar_skip_button',
  },
  NAV: {
    BACK_BUTTON: 'nav_back_button',
    LINK: 'nav_link',
    PROGRESS_BAR: 'progress_bar',
    HEADER: 'nav_header',
  },
  TOAST: {
    CLOSE_BUTTON: 'close_button',
  },
  OCCUPATION: {
    TITLE: 'occupation_title',
    NEXT_BUTTON: 'occupation_cta',
  },
  PERSONAL_INFO: {
    CARD_TITLE: 'peresonal_info_card_title',
    SUBMIT_CTA: 'personal_info_submit_cta',
    US_CITIZEN_CHECKBOX: 'checkbox_input',
    FIRST_NAME_FORM_ITEM: 'first_name_form_item',
    LAST_NAME_FORM_ITEM: 'last_name_form_item',
    DATE_OF_BIRTH_FORM_ITEM: 'date_of_birth_form_item',
    US_CITIZEN_CHECKBOX_FORM_ITEM: 'us_citizen_checkbox_form_item',
  },
  PLAY_BUTTON: 'play_button',
  PORTFOLIO_OVERVIEW: {
    TITLE: 'hero_title',
    BODY: 'hero_body',
    DOLLAR_CONTAINER: 'portfolio_overview_dollar_container',
    BONDS_PERCENT: 'portfolio_overview_bonds_percent',
    STOCKS_PERCENT: 'portfolio_overview_stocks_percent',
    REAL_STATE_PERCENT: 'portfolio_overview_real_state_percent',
  },
  POTENTIAL_GRAPH: {
    SLIDER: 'potential_graph_slider',
  },
  PRICING_INTERSTITIAL: {
    COMPARE_TIERS_BUTTON: 'compare_tiers_button',
    TIER_NAME: 'pricing_interstitial_tier_name',
    TIER_PRICE: 'pricing_interstitial_tier_price',
    BENEFITS_CONTAINER: 'pricing_interstitial_tier_benefits',
    BUNDLE_CONTAINER: 'pricing_interstitial_tier_bundle_container',
    CTA: 'pricing_interstitial_cta',
    IMAGE: 'pricing_interstitial_image',
    PILL: 'pill',
  },
  PREVIEW_PORTFOLIO: {
    TITLE: 'hero_title',
    PROJECTION_TITLE: 'preview_portfolio_projection_title',
    DESCRIPTION_TITLE: 'preview_portfolio_description_title',
    BODY: 'hero_body',
    BUTTON: 'preview_portfolio_button',
    BONDS_PERCENT: 'preview_portfolio_bonds_percent',
    STOCKS_PERCENT: 'preview_portfolio_stocks_percent',
    PORTFOLIO_ETF: 'portfolio_etf',
    ABOUT_ESG_LINK: 'about_esg_link',
    PORTFOLIO_RECOMMENDED_RISK: 'portfolio_recommended_risk',
  },
  REACT_PLAYER_VIDEO: 'react_player_video',
  REFERRAL_BANNER: {
    BANNER_TXT: 'referral_banner_text',
  },
  ROUNDUPS_INTERSTITIAL: {
    IMAGE: 'round_ups_interstitial_image',
    NEXT_BUTTON: 'round_ups_interstitial_next_cta',
    MORE_INFO: 'round_ups_interstitial_more_info',
  },
  ROUNDUPS_SETUP: {
    AUTOMATIC_OPTION: 'roundups_setup_automatic_option',
    MANUAL_OPTION: 'roundups_setup_manual_option',
    NEXT_BUTTON: 'round_ups_setup_next_cta',
  },
  ROUNDUPS_FUNDING: {
    TITLE: 'round_ups_funding_title',
    LINKED_ACCOUNT: 'round_ups_funding_linked_account',
    CHECKING_OPTION: 'plaid_checking',
    SAVINGS_OPTION: 'plaid_saving',
    OPTION_TOGGLE: 'round_ups_funding_option_toggle',
    NEXT_BUTTON: 'round_ups_funding_next_cta',
  },
  ROUNDUPS_PAST: {
    MOBILE_TOTAL_COST: 'round_ups_past_mobile_total_cost',
    NEXT_BUTTON: 'round_ups_past_next_cta',
    SKIP_BUTTON: 'nav_link',
  },
  SECOND_CHANCE: {
    ROUND_UPS_INTERSTITIAL_TEXT: 'round_ups_interstitial_text',
  },
  SELECT_PORTFOLIO_THEME: {
    CORE_BUTTON: 'portfolio_theme_select_core_button',
    SUSTAINABLE_BUTTON: 'portfolio_theme_select_sustainable_button',
    LEARN: 'portfolio_theme_select_learn_button',
    NEXT: 'portfolio_theme_select_next_button',
  },
  SELECT_TIER: {
    HEADER: 'select_tier_header',
    BODY: 'select_tier_body',
    CARD: {
      TITLE: 'select_tier_card_title',
      PRICE: 'select_tier_card_price',
      CTA: 'select_tier_card_cta',
    },
  },
  SIGN_YOUR_CARD: {
    SIGN_WITH_PHONE_BUTTON: 'sign_with_phone_button',
    NEXT_BUTTON: 'sign_your_card_next',
    SIGN_WITH_PHONE_MODAL: 'sign_with_phone_modal',
    SEND_LINK_BUTTON: 'send_link_button',
    MODAL_CLOSE_BUTTON: 'sign_with_phone_modal_close_button',
  },
  SIGNUP: {
    INPUT_EMAIL: 'signup_email_input',
    GET_STARTED_BUTTON: 'signup_get_started_button',
    CREATE_ACCOUNT_BUTTON: 'signup_create_button',
    AGREEMENT_MODAL: 'signup_agreement_modal',
    ONE_SPECIAL_CHAR_ERROR: 'validation-item-error-one_special_char',
    RESUME_MODAL: 'signup_resume_modal',
  },
  SPINNER: 'spinner',
  SSN: {
    HEADLINE: 'ssn_headline',
    SUBTITLE: 'ssn_subtitle',
    FOOTER: 'ssn_footer',
    SUBMIT_CTA: 'ssn_submit_cta',
    ECBSV_MODAL_PRIMARY_CTA: 'ssn_ecbsv_modal_primary_cta',
    ECBSV_MODAL_SECONDARY_CTA: 'ssn_ecbsv_modal_secondary_cta',
  },
  START_INVESTING: {
    LATER_RECURRING_TITLE: 'start_investing_later_recurring_title',
    LATER_ONE_TIME_TITLE: 'start_investing_later_one_time_title',
    RECURRING_SUBTITLE: 'start_investing_subtitle',
    LINK_BANK_ACCOUNT_BUTTON: 'link_bank_account_button',
    SUBMIT_CTA: 'start_investing_submit_cta',
    SKIP_CTA: 'start_investing_skip_cta',
    MAKE_ONE_TIME_BUTTON: 'make_one_time_button',
    ONE_TIME_TITLE: 'start_investing_one_time_title',
    ONE_TIME_SUBTITLE: 'start_investing_one_time_subtitle',
  },
  SUCCESS: {
    SUCCESS_MESSAGE: 'success_message',
    CHANGE_EMAIL_LINK: 'change_email_link',
    LOGIN_CTA: 'login_cta',
    APP_STORE: 'app_store_cta',
    GOOGLE_PLAY: 'google_play_cta',
    OPEN_ACORNS_CTA: 'success_open_acorns_cta',
    EARLY_TIER: {
      IMAGE: 'early_tier_success_image',
      NEXT_CTA: 'early_tier_next_cta',
      UNVERIFIED_CTA: 'early_tier_unverified_cta',
    },
    LATER_ONBOARDING: {
      TITLE: 'success_later_onboarding_title',
      SUBMIT_CTA: 'success_later_onboarding_submit_cta',
      IMAGE: 'success_later_onboarding_image',
    },
  },
  SUITABILITY_QUESTIONS: {
    SUBMIT_CTA: 'suitability_questions_submit_cta',
    QUESTION_TITLE: 'suitability_questions_question_title',
    ANSWER: 'suitability_questions_answer',
    ANSWER_DESCRIPTION: 'suitability_questions_answer_description',
    CLICKABLE_OPTION: 'suitability_questions_clickable_option',
    PROGRESS_BAR: 'suitability_questions_progress_bar',
  },
  UTILS: {
    PROMPT_MODAL: 'utils_prompt_modal',
  },
  WELCOME: {
    LATER_ONBOARDING: {
      HERO_IMAGE: 'later_onboarding_hero_image',
      SUBMIT_CTA: 'later_onboarding_submit_cta',
      SUBSCRIPTION_INCLUDES_LATER_TEXT: 'later_onboarding_subscription_includes_later_text',
      SUBSCRIPTION_SUBTEXT: 'later_onboarding_subscription_subtext',
      HEADING: 'later-onboarding-heading',
      SUBHEADING: 'later-onboarding-subheading',
      INTRO_CONTENT: 'later-onboarding-intro-content',
      DETAILS_CONTENT: 'later-onboarding-details-content',
      ONBOARDING_CTA: 'later-onboarding-cta',
      ONBOARDING_MOBILE_CTA: 'later-onboarding-mobile-cta',
    },
  },
  MAINTENANCE: {
    CARD: 'maintenance_card',
  },
  ERROR_STATE: {
    CONTAINER: 'error_state_container',
  },
  MODAL: {
    BODY: 'modal_body',
    PRIMARY_BUTTON: 'button_0',
    SECONDARY_BUTTON: 'button_1',
    LABEL: 'modal_label',
    DESCRIPTION: 'modal_description',
  },
  PROGRESS_TRACKER: {
    TITLE: 'progress_tracker_title',
    BODY: 'progress_tracker_body',
    CTA: 'progress_tracker_cta',
    ASSET: 'progress_tracker_asset',
  },
  HDYHAU: {
    TITLE: 'hdyhau_title',
    OPTION: 'hdyhau_option',
    CTA: 'hdyhau_cta',
  },
  CHOOSE_FUNDING_SOURCE: {
    ACCOUNT: 'choose_funding_source_account',
    SELECTED_ICON: 'choose_funding_source_selected_icon',
    UNSELECTED_ICON: 'choose_funding_source_unselected_icon',
  },
  FORM: {
    INPUT_TEXT: 'text_input',
    LABEL_TEXT: 'text_input_label',
    ERROR: 'field_error',
    OPTION_TOGGLE: 'form_option_toggle',
  },
  PRODUCT_ONBOARDING: {
    PRODUCT_CONTAINER: 'product_onboarding_product_container',
    CONFIRM_CTA: 'product_onboarding_confirm_cta',
  },
  PROMINENCE_BANNER: {
    CONTAINER: 'prominence_banner_container',
    TITLE: 'prominence_banner_title',
    ICON: 'prominence_banner_icon',
    DISMISS_BUTTON: 'prominence_banner_dismiss_button',
  },
  DRAWER: {
    TITLE: 'drawer_title',
    BODY: 'drawer_body',
    IMAGE: 'drawer_image',
    CLOSE_BUTTON: 'drawer_close_button',
  },
  PAGE_LAYOUT: {
    HEADLINE: 'page_layout_headline',
    SUBTITLE: 'page_layout_subtitle',
  },
  PROMO_CODES: {
    PROMO_CODE_APPLIED_CODE: 'promo_code_applied_code',
    PROMO_CODE_CTA: 'promo_code_cta',
    PROMO_CODE_DRAWER: 'promo_code_drawer',
    PROMO_CODE_DRAWER_FORM: 'promo_code_drawer_form',
    PROMO_CODE_DRAWER_INPUT: 'promo_code_drawer_input',
  },
  SUBSCRIPTION_ACTIVE: {
    CTA: 'subscription_active_cta',
  },
  DATE_OF_BIRTH: {
    CTA: 'date_of_birth_cta',
  },
}

export { TestIDs }
